import { IFreeInputable, instanceOfIFreeInputable } from "../../../../domain/document/items";

export interface IFreeInputableWrappedObject extends IFreeInputable {
}

export function instanceOfIFreeInputableWrappedObject(instance: any): instance is IFreeInputableWrappedObject {
  return instanceOfIFreeInputable(instance);
}
